import axios, { AxiosResponse } from 'axios'

export async function getFee() {
  const axiosResponse: AxiosResponse | unknown = await axios({
    method: 'get',
    url: 'https://gasstation-mainnet.matic.network/v2',
  })
  const {
    fast: { maxFee, maxPriorityFee },
  } = (axiosResponse as AxiosResponse).data
  return { maxFee, maxPriorityFee }
}

export function getGasPriceExtra(gasPrice: string, extraRate = 1.2): bigint {
  return BigInt(Math.ceil(Number(gasPrice) * extraRate))
}

export function prepareErrorMessage(errorMessage: string): string {
  const match = errorMessage.match(/:/g)
  return match ? errorMessage.split(':')[1] : errorMessage
}
